// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".company-subscription[data-v-00636557]{display:flex;flex-wrap:wrap;gap:8px 20px;align-items:center;margin-bottom:18px;padding:12px 16px;border:1px solid var(--pult-line);border-radius:10px;color:var(--pult-muted);background:var(--pult-surface)}.company-subscription--warning[data-v-00636557]{border-color:var(--pult-accent);color:var(--pult-text)}.company-subscription a[data-v-00636557]{margin-left:auto}", ""]);
// Exports
module.exports = exports;
